module.exports = __webpack_public_path__ + "Badge_LifehackLessons-1ad64b847c971e2858d3c46ab13c2bad.svg";